import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  container: {
    display: 'block',
    margin: '0 auto',
    maxWidth: 550,
    marginTop: theme.spacing(5.625),
  },
  titleContainer: {
    paddingBottom: theme.spacing(1.25),
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  sampleTemplate: {
    maxHeight: 36,
  },
}));
